import { BaseModel } from '../base/base-model'

/**
 * @memberOf loavies.models.user
 * @constructor
 */
export class UserPrivateDataModel extends BaseModel {
  /**
   * @param {Array<string>} [wishlist]
   * @param {boolean} [chatBrowserNotificationsEnabled]
   * @param {boolean} [accountOnboardingEnabled]
   * @param {boolean} [generalOnboardingEnabled]
   * @param {number} [lastEventSequenceIdNotificationShown]
   * @param {number} [lastEventSequenceIdMessageRead]
   */
  constructor({
    wishlist,
    chatBrowserNotificationsEnabled,
    accountOnboardingEnabled,
    generalOnboardingEnabled,
    lastEventSequenceIdNotificationShown,
    lastEventSequenceIdMessageRead,
  }) {
    super()

    /** @type {Array<string>} */
    this.wishlist = wishlist ?? []

    /** @type {boolean} */
    this.chatBrowserNotificationsEnabled = chatBrowserNotificationsEnabled ?? false

    /** @type {boolean} */
    this.accountOnboardingEnabled = accountOnboardingEnabled ?? true

    /** @type {boolean} */
    this.generalOnboardingEnabled = generalOnboardingEnabled ?? true

    /** @type {number} */
    this.lastEventSequenceIdNotificationShown = lastEventSequenceIdNotificationShown ?? 0

    /** @type {number} */
    this.lastEventSequenceIdMessageRead = lastEventSequenceIdMessageRead ?? 0
  }
}
